import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const expandAtom = atomWithStorage("expand", false);

/** Controls the expanding card feature when Accordion's are opened or
 * when dedicated expand button is triggered. */
export const useExpandStore = () => useAtom(expandAtom);
